import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties/StringProperty';

export const SpliceSchema = new GenericModelSchema('splice', {
  category: ModelCategory.ComponentDesignData,

  properties: {
    name: StringProperty,
  },
});
